import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { LoginRoutingModule } from './routes/login-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login.component';
import { FirstAccessComponent } from './components/first-access/first-access.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { SharedModule } from 'src/app/shared/shared.module';
import {GenericButtonV2Component} from '@shared/components/button/generic-button-v2/generic-button-v2.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        NgxMaskDirective,
        NgxMaskPipe,
        LoginRoutingModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        GenericButtonV2Component
    ],
  declarations: [
     LoginComponent,
     FirstAccessComponent,
     WelcomeComponent
  ],
  providers: [],
})

export class LoginModule {}
